/* eslint-disable max-len */
import React, { useState, useEffect } from 'react'
import NumberFlow from '@number-flow/react'
import AppFeature from './features/app'

const FeatureBlockIntro = () => {
   const [numCommunityMembers, setNumCommunityMembers] = useState(0)
   const [numCountries, setNumCountries] = useState(0)
   const [numPayments, setNumPayments] = useState(0)

   useEffect(() => {
      const handleScroll = () => {
         const featureBlock = document.getElementById('features')

         if (window.scrollY >= featureBlock.offsetTop - 500 &&
            window.scrollY <= featureBlock.offsetTop + 300) {
            setNumCommunityMembers(3)
            setNumCountries(192)
            setNumPayments(4)
         } else {
            setNumCommunityMembers(0)
            setNumCountries(0)
            setNumPayments(0)
         }
      }

      window.addEventListener('scroll', handleScroll)
      return () => window.removeEventListener('scroll', handleScroll)
   }, [])

   return (
      <div className="communities-content-wrapper text-white pb-8 md:pb-24 pt-24 border-t border-solid border-white/20">
         <div className="max-w-2xl mx-auto md:text-center">
            <div className="text-[36px] sm:text-[40px] md:text-[40px] lg:text-[38px] xl:text-[44px] leading-[1.1] font-serif-title tracking-tighter font-medium xl:mt-8 mb-4">
               All-in-one platform
            </div>
            <div className="text-base opacity-70">
               Bring all your people, content, resources and conversations together in one place. No more need to juggle multiple tools to organize your community. From events to groups to rich discussions, Communities helps you manage it all seamlessly in one place.
            </div>
         </div>
         <div className="max-w-3xl mx-auto sm:grid grid-cols-3 sm:pt-8 sm:pb-12 text-base sm:text-center divide-y sm:divide-y-0 sm:divide-x divide-solid divide-white/20">
            <div className="flex flex-col sm:items-center py-6 sm:py-10">
               <div className="text-2xl md:text-3xl font-semibold">
                  <NumberFlow value={numCommunityMembers} suffix=" Million" />
               </div>
               <div className="opacity-70">Community Members</div>
            </div>
            <div className="flex flex-col sm:items-center py-6 sm:py-10">
               <div className="text-2xl md:text-3xl font-semibold">
                  <NumberFlow value={numCountries} />
               </div>
               <div className="opacity-70">countries</div>
            </div>
            <div className="flex flex-col sm:items-center py-6 sm:py-10">
               <div className="text-2xl md:text-3xl font-semibold">
                  <NumberFlow
                     format={{ style: 'currency', currency: 'USD', trailingZeroDisplay: 'stripIfInteger' }}
                     value={numPayments}
                     suffix=" Million"
                  />
               </div>
               <div className="opacity-70">in payments processed</div>
            </div>
         </div>
         <div className="relative overflow-hidden w-full aspect-[3/2] sm:aspect-video bg-[#00180f]/20 rounded-[30px] lg:rounded-[100px] mb-12 mt-8 sm:mt-0">
            <AppFeature />
         </div>
         <div className="w-full text-center text-xs sm:text-sm opacity-40 mb-12 lg:mb-32">
            Communities is a great place to create a personalized, tailored experience unique to your community.
         </div>
      </div>
   )
}

export default FeatureBlockIntro
